export default __webpack_public_path__ + "static/media/logo-dark.0ee142d7.svg";